import type { User } from 'types/user';
import { create, useStore } from 'zustand';

interface UserStore {
  statistic: Record<string, unknown>;
  users: User[];
  isUsersLoading: boolean;
  totalUsers: number;
  totalPages: number;
  totalItems: number;
}

export const usersStore = create<UserStore>((_set) => ({
  statistic: {},
  users: [],
  isUsersLoading: false,
  totalUsers: 0,
  totalPages: 0,
  totalItems: 0,
}));

export const useUsersStore = () => useStore(usersStore);
